import { UrlTargetEnumTarget, } from '@wix/ambassador-forms-v4-form/types';
export const redirectToExternalUrl = (redirectOptions) => {
    const urlWithoutProtocol = redirectOptions?.redirectUrl?.replace(/^https?:\/\//, '');
    const updatedExternalUrl = `https://${urlWithoutProtocol}`;
    window.open(updatedExternalUrl, redirectOptions?.target === UrlTargetEnumTarget.SELF ? '_self' : '_blank');
};
export const isValidUrl = (url) => {
    const urlPattern = new RegExp(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/g);
    return urlPattern.test(url);
};
export const getErrorCode = (error) => {
    return (error?.response?.data?.details?.applicationError?.code ||
        (error?.code && String(error?.code)) ||
        error?.response?.data?.details?.validationError?.fieldViolations?.[0]?.data
            ?.errors?.[0]?.errorType ||
        'UNKNOWN');
};
export const getErrorList = (error) => {
    return error?.response?.data?.details?.validationError?.fieldViolations?.[0]
        .data.errors;
};
export const getFormCustomErrorMessage = (errors) => errors?.filter((error) => error.useCustomErrorMessage && !error.errorPath)?.[0]?.errorMessage;
export const getFieldCustomErrorMessages = (errors) => errors?.filter((error) => error.useCustomErrorMessage && error.errorPath);
export const getCheckoutMessage = (text) => {
    return {
        nodes: [
            {
                id: 'ymnqxbmks',
                type: 'PARAGRAPH',
                paragraphData: {
                    textStyle: {
                        textAlignment: 'CENTER',
                    },
                },
                nodes: [
                    {
                        nodes: [],
                        id: '',
                        type: 'TEXT',
                        textData: {
                            text,
                            decorations: [],
                        },
                    },
                ],
            },
        ],
        metadata: {
            version: 1,
            id: 'af4951a2-dd8f-44ec-b2dc-cb4c09f65ee9',
        },
    };
};
//# sourceMappingURL=utils.js.map